import React from "react";
import clsx from "clsx";

import {mergeClasses} from "@material-ui/styles";
import {withStyles} from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";

import CheckboxFormElement from "../../../../formElement/CheckboxFormElement/CheckboxFormElement";
import BaseDialog from "../../../../../../../../../components/BaseDialog/BaseDialog";
import {PrimaryButton} from "../../../../../../../../../components/Buttons";
import SafeHtml from "../../../../../../../../../components/SafeHtml";

import styles from "./styles";

export const Info = withStyles(styles)(({classes, info, label}) => {
  const [isInfoOpen, setInfoOpen] = React.useState(false);
  const handleInfoClose = () => setInfoOpen(false);

  return (
    <Grid item xs={'auto'} style={{marginLeft: 'auto'}} onClick={(e) => e.stopPropagation()}>
      <div className={classes.infoIcon} onClick={() => setInfoOpen(true)}>
        <i className={"far fa-info-circle"}/>
      </div>
      <BaseDialog
        open={isInfoOpen}
        title={
          <Grid container spacing={1} alignItems={"center"}>
            <Grid item xs={'auto'}><i className={clsx('far fa-info-circle', classes.dialogTitleIcon)}/></Grid>
            <Grid xs={true}>{label}</Grid>
          </Grid>
        }
        handleClose={handleInfoClose}
        customClasses={{
          dialogTitle: classes.dialogTitleInfo,
          dialogContent: classes.dialogContent
        }}
        maxWidth={'sm'}
        actions={
          <Grid container justify={"flex-end"}>
            <Grid item>
              <PrimaryButton
                text={'Schließen'}
                variant={'outlined'}
                onButtonClick={handleInfoClose}
              />
            </Grid>
          </Grid>
        }
      ><SafeHtml html={info} /></BaseDialog>
    </Grid>
  )
});

const CheckboxCard = props => {
  const {
    classes,
    value,
    onChange,
    disabled,
    label,
    name,
    required,
    error,
    info,
    helpText,
    custom_classes,
  } = props;

  return (
    <Grid container className={clsx(classes.checkboxQuestionContainer, value && 'checked', disabled && 'disabled')} onClick={onChange}>
      <Grid item xs>
        <CheckboxFormElement
          value={value}
          label={label}
          name={name}
          required={required}
          custom_classes={
            mergeClasses({
              baseClasses: {root: 'newDesign', label: 'newDesign', radio: 'newDesign'},
              newClasses: custom_classes,
              Component: CheckboxFormElement
            })
          }
          error={error}
          helpTextUsed={!!helpText}
        />
      </Grid>
      {!!info && <Info info={info} label={label} />}
      {helpText && <Grid item xs={12} className={classes.helpText}>{helpText}</Grid>}
    </Grid>
  )
};

export default withStyles(styles)(CheckboxCard);